import React, { useState } from 'react';
import { InventoryItem } from '../../types/item';
import { Button } from '../ui';
import { ButtonVariant, ButtonSize, BarcodeTemplate } from '../../types/ui';
import { usePrintBarcode } from './PrintBarcodeProvider'; // Import usePrintBarcode

interface BarcodeButtonProps {
  barcode: string;
  item?: InventoryItem;
  buttonText?: string;
  className?: string;
  icon?: React.ReactNode;
  template?: BarcodeTemplate;
}

/**
 * Button component that opens a barcode print modal when clicked
 */
const BarcodeButton: React.FC<BarcodeButtonProps> = ({
  barcode,
  item,
  buttonText = 'Barkod Yazdır',
  className = '',
  icon,
  template = BarcodeTemplate.A
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false); // This state will be removed
  const { printBarcode } = usePrintBarcode(); // Use the context hook

  if (!barcode) {
    return null;
  }

  const handleClick = () => {
    printBarcode(barcode, item, template); // Call printBarcode from context
  };

  return (
    <>
      <Button
        onClick={handleClick} // Updated onClick handler
        variant={ButtonVariant.SECONDARY}
        size={ButtonSize.SMALL}
        className={className}
      >
        {icon && <span className="mr-1">{icon}</span>}
        {buttonText}
      </Button>

      {/* Remove BarcodePrintModal instance from here */}
      {/*
      <BarcodePrintModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        barcode={barcode}
        item={item}
        template={template}
      />
      */}
    </>
  );
};

export default BarcodeButton; 